export const testModuleChiTietMenuI18n = {
  testModuleChiTiet: 'TEST MODULE',
  testModuleChiTietPage: {
    title: 'TEST MODULE CHI TIẾT',
    description:
      'Mỗi module: Test UI (thao tác màn thật, chụp ảnh). Nhóm Đơn hàng thêm nút Tạo DL (mặc định 5 bản ghi, sửa được số lượng).',
  },
} as const
